import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";

type Beneficiary = {
  account_number?: string;
  account_name?: string;
  bank_name?: string;
  visaro_username?: string;
  visaro_user: boolean;
  name: string;
};

function useBeneficiaries(
  options?: QueryObserverOptions<APIResponse<Beneficiary[]>, APIError>
) {
  const {
    isLoading: fetchingBeneficiaries,
    isError: isBeneficiariesError,
    data: beneficiaries,
    refetch: refreshBeneficiaries,
  } = useQuery<APIResponse<Beneficiary[]>, APIError>(
    "beneficiaries",
    async () =>
      await get(API_URL + "/account/banking/beneficiary", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    fetchingBeneficiaries,
    isBeneficiariesError,
    beneficiaries,
    refreshBeneficiaries,
  };
}

export default useBeneficiaries;
